import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const Reviews = () => {
  const [currentPage, setCurrentPage] = useState(0);

  const reviews = [
    {
      id: 1,
      title: "Reliable and Quick Service",
      content:
        "CNL has been our go-to for diesel delivery for the past 6 months. Their on-time delivery and quality service has helped us maintain our construction site operations smoothly. The drivers are professional and the diesel quality is excellent.",
      author: "Rajesh Kumar",
      rating: 5,
      image: "https://i.pravatar.cc/150?img=12",
    },
    {
      id: 2,
      title: "Best Fuel Delivery in Delhi NCR",
      content:
        "Running a fleet of trucks, timely diesel delivery is crucial for us. CNL delivers exactly when promised and their competitive pricing has helped us reduce operational costs significantly. Highly recommend their services!",
      author: "Priya Sharma",
      rating: 5,
      image: "https://i.pravatar.cc/150?img=5",
    },
    {
      id: 3,
      title: "Professional and Efficient",
      content:
        "We use CNL for our factory's diesel requirements in Noida. The ordering process is simple, delivery is always on time, and their customer support team is very responsive. Great service overall!",
      author: "Amit Patel",
      rating: 5,
      image: "https://i.pravatar.cc/150?img=8",
    },
  ];

  const reviewsPerPage = 2;
  const totalPages = Math.ceil(reviews.length / reviewsPerPage);

  const nextSlide = () => {
    setCurrentPage((prev) => (prev + 1) % totalPages);
  };

  const prevSlide = () => {
    setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
  };

  const getCurrentPageReviews = () => {
    const start = currentPage * reviewsPerPage;
    return reviews.slice(start, start + reviewsPerPage);
  };

  return (
    <ReviewsSection id="reviews">
      <ReviewsContainer>
        <ReviewsHeader>
          <Title>Reviews</Title>
          <Subtitle>
            Don't just take our word for it. Here's what our customers across
            Delhi NCR say about our diesel delivery service.
          </Subtitle>
        </ReviewsHeader>

        <ReviewsGrid>
          <AnimatePresence mode="wait">
            {getCurrentPageReviews().map((review) => (
              <motion.div
                key={review.id}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                <ReviewCard>
                  <ReviewTitle>{review.title}</ReviewTitle>
                  <Stars>
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i}>★</Star>
                    ))}
                  </Stars>
                  <ReviewContent>{review.content}</ReviewContent>
                  <AuthorInfo>
                    <AuthorImage src={review.image} alt={review.author} />
                    <AuthorName>{review.author}</AuthorName>
                  </AuthorInfo>
                </ReviewCard>
              </motion.div>
            ))}
          </AnimatePresence>
        </ReviewsGrid>

        <NavigationButtons>
          <NavButton onClick={prevSlide} disabled={currentPage === 0}>
            <CircleButton>←</CircleButton>
          </NavButton>
          <NavButton
            onClick={nextSlide}
            disabled={currentPage === totalPages - 1}
          >
            <CircleButton>→</CircleButton>
          </NavButton>
        </NavigationButtons>
      </ReviewsContainer>
    </ReviewsSection>
  );
};

const ReviewsSection = styled.section`
  padding: 80px 5%;
`;

const ReviewsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
`;

const ReviewsHeader = styled.div`
  text-align: left;
  margin-bottom: 40px;
  margin-left: 30px;
`;

const Title = styled.h2`
  font-size: 36px;
  color: #1e3a8a;
  margin-bottom: 16px;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #64748b;
  max-width: 600px;
`;

const ReviewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 40px;
  min-height: 300px; /* Add fixed height to prevent layout shift */

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ReviewCard = styled.div`
  background: #fff;
  padding: 30px;
  border-radius: 8px;
`;

const ReviewTitle = styled.h3`
  font-size: 20px;
  color: #1e3a8a;
  margin-bottom: 12px;
`;

const Stars = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 16px;
`;

const Star = styled.span`
  color: #ffb800;
  font-size: 20px;
`;

const ReviewContent = styled.p`
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 24px;
  font-weight: 500;
`;

const AuthorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const AuthorImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

const AuthorName = styled.span`
  font-size: 14px;
  color: #1e3a8a;
  font-weight: 500;
`;

const NavigationButtons = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 8px;
`;

const NavButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const CircleButton = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e3a8a;
  font-size: 18px;
  transition: all 0.2s ease;

  &:hover {
    background: #1e3a8a;
    color: #fff;
    border-color: #1e3a8a;
  }
`;

export default Reviews;
